import React, { Component } from 'react';
import { ViewStyle } from 'react-native';
import { STheme, SView } from 'servisofts-component2';
import { SViewProps } from 'servisofts-component2/dist/types/Components/SView';

export default class Container extends Component<SViewProps & { contentContainerStyle?: ViewStyle }> {

    render() {
        return (
            <SView col={"xs-12"} center {...this.props} >
                <SView col={"xs-11 sm-10 md-8 lg-6 xl-4 xxl-3"} center flex={this.props.flex} row={this.props.row} style={this.props.contentContainerStyle}>
                    {this.props.children}
                </SView>
            </SView>
        );
    }
}
